import * as React from 'react'
import styled from 'styled-components'
import { Link } from '../../../../common/src/components/Link'
import { H4, Spacer, BodyText } from '../../../../common/src/components/core'
import { TestIds } from '../../../../common/src/data/testids'

const UnauthorizedContainer = styled.div`
  margin: 32px;
`

export class Unauthorized extends React.Component {
  render() {
    return (
      <UnauthorizedContainer data-testid={TestIds.unauthorizedContainer}>
        <H4 color="coral">you are unauthorized to view this page</H4>
        <Spacer height={16} />
        <Link to="/leasing/lobby">
          <BodyText>click here to go back to lobby</BodyText>
        </Link>
      </UnauthorizedContainer>
    )
  }
}
